import { useNavigate } from 'react-router-dom';

// material mui
import {
    Typography,
    Grid,
    Link,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';

// third party
import moment from 'moment-timezone';

const List = ({ rows }) => {

    const navigate = useNavigate();

    const handleViewVenue = (venueUuid) => {
        navigate(`/venue/view/${venueUuid}`)
    };

    const getDiff = (onDate, offDate) => {
        const startTime = moment(onDate.replace('T', ' ').replace('.000Z', ''), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        const endTime = moment(offDate.replace('T', ' ').replace('.000Z', ''), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        const duration = moment.duration(moment(endTime).diff(startTime));
        const hours = parseInt(duration.asHours());
        const minutes = parseInt(duration.asMinutes()) % 60;
        const seconds = parseInt(duration.asSeconds()) % 60;
        const hoursLabel = hours <= 1 ? 'hr' : 'hrs'
        const minutessLabel = minutes <= 1 ? 'min' : 'mins'
        const secondsLabel = seconds <= 1 ? 'sec' : 'secs'
        return `${hours} ${hoursLabel} ${minutes} ${minutessLabel} ${seconds} ${secondsLabel}`;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Venue</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>On Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Off Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Run Time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {
                                                    <Link
                                                        underline='always'
                                                        onClick={() => handleViewVenue(row.venue_uuid)}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        {row.venue_name ? row.venue_name : ''}
                                                    </Link>
                                                }
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.court_name ? row.court_name : ''} / {row.board_name ? row.board_name : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {moment(row.on_date.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {moment(row.on_date.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {
                                        row.on_date !== row.off_date ? (
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs zeroMinWidth>
                                                    <Typography align="left" variant="subtitle1" component="div">
                                                        {moment(row.off_date.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                                    </Typography>
                                                    <Typography align="left" variant="subtitle2" noWrap>
                                                        {moment(row.off_date.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        ) : ''
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {
                                        row.on_date !== row.off_date ? getDiff(row.on_date, row.off_date) : ''
                                    }
                                </TableCell>
                                {/* <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {moment.utc(moment.duration(6670, "seconds").asMilliseconds()).format("h:mm:ss")}
                                </TableCell> */}
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
        </TableContainer >
    );
}

export default List;